export const ProductSkeleton = () => (
  <div role="status" className="max-w-lg animate-pulse space-y-2.5">
    <div className="aspect-square w-full items-center justify-center rounded-lg bg-gray-200"></div>
    <div className="mt-2 flex flex-col gap-2">
      <div className="h-6 w-48 rounded-sm bg-gray-200"></div>
      <div className="h-6 w-32 rounded-sm bg-gray-200"></div>
      <div className="h-6 w-24 rounded-sm bg-gray-200"></div>
    </div>
  </div>
);
